import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core'
import { toggleDialog } from 'actions/view'
import Button from 'components/theme/Button'
import { create } from 'actions/data'

const styles = theme => ({
  container: {
    textAlign: 'center',
    padding: '24px 48px',
    [theme.breakpoints.down('sm')]: {
      padding: '24px 20px',
    },
  },
  text: {
    textAlign: 'left',
    fontSize: 22,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  resendText: {
    marginTop: 20,
    padding: '0 160px',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
})

class VerifyEmail extends Component {
  render() {
    return (
      <div className={this.props.classes.container}>
        <div className={this.props.classes.text}>
          If you would like to send from{' '}
          <span style={{ color: '#0068d7', fontWeight: 'bold' }}>
            {this.props.verify_my_address_status?.address}
          </span>{' '}
          please verify by pressing the verify button below.
        </div>
        {this.props.verify_my_address_status?.status === 'pending' && (
          <div className={this.props.classes.resendText}>
            *A verification email has been sent. Please check your email and
            click the link to verify your email. If you have nto received an
            email within 2 minutes, click the{' '}
            <strong>RE-SEND VERIFICATION EMAIL</strong> button below.
          </div>
        )}
        <div style={{ marginTop: 16 }}>
          <Button
            variant="contained"
            style={{
              backgroundColor: '#006fd9',
              color: '#fff',
              marginRight: 8,
              marginBottom: 8,
            }}
            onClick={() => {
              this.props.create({
                entity: null,
                entityType: 'email/verify_my_address',
                noReturnValue: true,
                hasSchema: false,
                snackbarMessage: `A verification email has been sent to ${
                  this.props.verify_my_address_status?.address || 'your email'
                }`,
              })

              this.props.toggleDialog({
                open: false,
                dialog: 'VerifyEmail',
              })
            }}
            color="primary"
          >
            {this.props.verify_my_address_status?.status === 'pending'
              ? 'Re-send verification email'
              : 'Verify Email'}
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: '#fb2f2f',
              color: '#fff',
              marginBottom: 8,
            }}
            onClick={() => {
              this.props.toggleDialog({
                open: false,
                dialog: 'VerifyEmail',
              })
            }}
            color="primary"
          >
            No I do not want to verify
          </Button>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    verify_my_address_status: state.data?.['email/verify_my_address_status'],
  }),
  dispatch => bindActionCreators({ toggleDialog, create }, dispatch),
)(withStyles(styles)(VerifyEmail))
